// Libraries
import React from 'react'
import Tour from 'reactour'

// Components
import MainButton from 'components/commons/MainButton'
import ButtonLink from 'components/commons/ButtonLink'

// Subcomponents
import StepContent from './StepContent'

// Services
import { useStateValue } from 'context/store'

// Styles
import welcomeTourStyles from './styles'

function WelcomeTour() {
   const classes = welcomeTourStyles()

   const [{ playWelcomeTour = {} }, dispatch] = useStateValue()

   function closeTour() {
      dispatch({ type: 'CLOSE_MENU_DRAWER' })
      dispatch({ type: 'DONT_PLAY_WELCOME_TOUR' })
   }

   function handleNextButton() {
      dispatch({ type: 'CLOSE_MENU_DRAWER' })
   }

   return (
      <Tour
         className={classes.content}
         isOpen={Boolean(playWelcomeTour.play)}
         steps={steps}
         prevStep={closeTour}
         prevButton={<ButtonLink text="OMITIR" />}
         nextButton={
            <MainButton
               text="CONTINUAR"
               addMargin={false}
               onClick={handleNextButton}
            />
         }
         lastStepNextButton={
            <MainButton
               text="FINALIZAR"
               addMargin={false}
               onClick={closeTour}
            />
         }
         showNavigation={false}
         showCloseButton={false}
         showNumber={false}
         startAt={1}
      />
   )
}

export default WelcomeTour

// ----------------------------------------------------------

const MAIN_MENU_TEXT = `Aquí podrás acceder al catálogo de aplicaciones de
la organización, agrupadas por Subdominios.`

const USER_PROFILE_TEXT = `Aquí encuentras la información del usuario logueado.
Así mismo las opciones: Cambiar Contraseña, consulta de las Políticas del Sitio,
acceso a las PQR y opción Salir.`

const NOTIFICATIONS_SUMMARY_TEXT = `Aquí encuentras el resumen de las Notificaciones
centralizadas de las diferentes aplicaciones integradas al portal.`

const HELP_TEXT = `Aquí accedes a las opciones Asuntos legales,
Circulares y Normativas.`

const MUNDO_MUTUAL = `Espacio de desarrollo de competencias que permite comunicar al usuario final temas que apalancan la estrategia de apropiación del conocimiento de cómo usar las aplicaciones integradas, videos de formación.`

const NOTIFICATIONS_TEXT = `Aquí encuentras Notificaciones centralizadas de
las diferentes aplicaciones integradas al portal.`

const steps = [
   /*
		NOTA: El "prevButton" está deshabilitado en el 1er step por default, no serviría el botón "OMITIR".
		Se agrega un fake 1er step vacío ({}) para que quede habilitado el botón "OMITIR" de entrada.
	*/
   { content: () => null },
   {
      selector: '[data-wt="welcometour_leftmenu"]',
      content: () => (
         <StepContent title="Menú Principal" text={MAIN_MENU_TEXT} />
      )
   },
   {
      selector: '[data-wt="welcometour_userprofile"]',
      content: () => (
         <StepContent title="Perfil de Usuario" text={USER_PROFILE_TEXT} />
      )
   },
   {
      selector: '[data-wt="welcometour_notificationssummary"]',
      content: () => (
         <StepContent
            title="Botón Notificaciones"
            text={NOTIFICATIONS_SUMMARY_TEXT}
         />
      )
   },
   {
      selector: '[data-wt="welcometour_help"]',
      content: () => <StepContent title="Botón Ayuda" text={HELP_TEXT} />
   },
   {
      selector: '[data-wt="welcometour_mundoMutual"]',
      content: () => <StepContent title="Mundo Mutual" text={MUNDO_MUTUAL} />
   },
   {
      selector: '[data-wt="welcometour_notifications"]',
      content: () => (
         <StepContent
            title="Espacio para Notificaciones"
            text={NOTIFICATIONS_TEXT}
         />
      )
   }
]
